/**
 * Connecting UI shown while Copilot Direct Line session initializes.
 */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { AIAssistantIcon } from './AIAssistantIcon';
import {
  copilotConnectingContentSx,
  copilotConnectingDotsRowSx,
  copilotConnectingIconShellSx,
  copilotConnectingRootSx,
  copilotConnectingSubtitleSx,
  copilotConnectingTitleSx,
  getCopilotConnectingDotSx,
} from './copilot.styles';

export const CopilotConnectingState: React.FC = () => (
  <Box sx={copilotConnectingRootSx}>
    <Box sx={copilotConnectingContentSx}>
      <Box sx={copilotConnectingIconShellSx}>
        <AIAssistantIcon size={32} />
      </Box>

      <Box>
        <Typography sx={copilotConnectingTitleSx}>Connecting AI Assistant</Typography>
        <Typography sx={copilotConnectingSubtitleSx}>
          Setting up a secure connection — this only takes a moment.
        </Typography>
      </Box>

      <Box sx={copilotConnectingDotsRowSx}>
        {[0, 1, 2].map((index) => (
          <Box key={index} sx={getCopilotConnectingDotSx(index)} />
        ))}
      </Box>
    </Box>
  </Box>
);

export default CopilotConnectingState;
